import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { PatchBoardInvitationRequestParams } from '../types';

export const patchBoardInvitation = async ({
  path: { organisationId, boardId, invitationId },
}: PatchBoardInvitationRequestParams) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/invitations/${invitationId}`;
  await apiAuthClient.patch(url);
};
